module.exports = __webpack_public_path__ + "media/images/athletes/1810-fd7e5308cfbb418eeab2f5991d2a11da.png";